import { render } from "./Information.vue?vue&type=template&id=239fbb2e&scoped=true&ts=true"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"

import "./Information.vue?vue&type=style&index=0&id=239fbb2e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239fbb2e"]])

export default __exports__